<template>
  <div
    v-if="withQualifier"
    class="sectionWithQualifier"
  >
    <span v-if="info && showBtnTablePatternColumn(infoValues)">
      <a
        href="#"
        class="label labelWithQualifier"
        :aria-label="columnName"
        @click.prevent.stop="showModal()"
      >
        <b-icon
          icon="eye"
          size="is-small"
          class="iconEyesWithQualifier"
          type="is-dark"
        />
        {{ columnName }}
      </a>
      <LoadingAnimate
        v-if="isLoading"
        :size="'is-small'"
      />
    </span>
    <!-- modal de multiplicity et dynamique colonne -->
    <b-modal
      v-model="isCardModalActive"
      class="referenceDetails"
      @close="closeModal()"
    >
      <div class="card">
        <div class="card-header">
          <div class="title card-header-title">
            <p
              field="name"
              :aria-label="columnTitle.match('.*::(.*)') ? columnTitle.match('.*::(.*)')[1] : columnTitle"
            >
              {{ columnTitle.match(".*::(.*)") ? columnTitle.match(".*::(.*)")[1] : columnTitle }}
            </p>
          </div>
        </div>
        <div class="card-content">
          <b-table
            id="patternFilterTable"
            :data="[0]"
            :is-focusable="true"
            :is-hoverable="true"
            :sticky-header="false"
            striped
            class="tableWithQualifier"
          >
            <b-table-column
              v-for="column in value"
              :key="column.id"
              :field="column.id"
              sortable
            >
              <template #header>
                <div
                  :aria-label="column.columnName"
                  class="columnName"
                >
                  {{ column.columnName }}
                </div>
              </template>
              <template #default>
                <DatasLink
                  :application="application"
                  :column-id="column.component.id"
                  :column-title="column.component.title"
                  :component="column.component"
                  :display-value="'' + column.value"
                  :loaded-references-by-key="{}"
                  :pattern-checker-date="
                    patternCheckerDateRef(
                      application,
                      column.component.parentComponentKey + '::' + column.component.id,
                      dataId
                    )
                  "
                  :reference-type="column.component.refLinkedTo"
                  :value="'' + column.value"
                />
              </template>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </b-modal>
  </div>
  <div
    v-else
    :aria-label="patternLinkHeader"
  >
    {{ patternLinkHeader }}
  </div>
</template>

<script lang="ts">
import services from "@/composable/services";
import useBoolean from "@/composable/components/boolean";
import DatasLink from "@/components/datas/DatasLink.vue";
import { computed } from "vue";
import LoadingAnimate from "@/components/common/LoadingAnimate.vue";

export default {
  name: "DatasPatternLink",
  components: { LoadingAnimate, /* LoadingAnimate, DatasManyLink, */ DatasLink },
  props: {
    withQualifier: Boolean,
    application: Object,
    columnTitle: String,
    value: Array,
    infoValues: {},
    loadedReferencesByKey: {
      type: Object,
    },
    dataId: String,
    info: Boolean,
    isSticky: Boolean,
    columnId: String,
    patternCheckerDateRef: Function,
  },
  emits: ["change-sticky"],
  setup(props, ctx) {
    const isCardModalActive = useBoolean().refBoolean;
    const isLoading = useBoolean().refBoolean;

    function showBtnTablePatternColumn(tablePatternColumn) {
      let showModal = Object.entries(tablePatternColumn)
        .filter(a => a[1])
        .map(function (a) {
          let obj = {};
          obj[a[0]] = a[1];
          return obj;
        });
      return showModal.length !== 0;
    }
    const patternLinkHeader = computed(() => {
      // application.configuration.i18n.data.t_swc_swc.components.swc_variable.exportHeader.title.fr
      return services.internationalisationService.localeReferenceColumnsNames(
        props.dataId,
        props.columnTitle,
        props.application,
      );
    });

    const columnName = computed(() => {
      let pattern = props.columnTitle.match(".*::(.*)");
      return pattern ? pattern[1] : props.columnTitle;
    });

    async function showModal() {
      isLoading.value = true;
      isCardModalActive.value = true;
      isLoading.value = false;
      if (isCardModalActive.value === props.isSticky) {
        ctx.emit("change-sticky", !props.isSticky);
      }
      return props.value;
    }

    async function closeModal() {
      isCardModalActive.value = false;
      if (isCardModalActive.value === props.isSticky) {
        ctx.emit("change-sticky", !props.isSticky);
      }
    }

    return {
      patternLinkHeader,
      columnName,
      isLoading,
      isCardModalActive,
      showBtnTablePatternColumn,
      showModal,
      closeModal,
    };
  },
};
</script>
